import React, { forwardRef } from 'react';
import { FEATURE_ID } from '../../../Common/constant';
import imgpartner2 from "../../../assets/images/partners/g-workforce2.png";
import imgpartner3 from "../../../assets/images/partners/mintegra.png";
import imgpartner1 from "../../../assets/images/partners/vsim.png";


import imgclient1 from "../../../assets/images/clients/freeport.png";
import imgclient2 from "../../../assets/images/clients/coalmine.png";
import imgclient3 from "../../../assets/images/clients/ppa.png";
import imgclient4 from "../../../assets/images/clients/vale.png";
import imgclient5 from "../../../assets/images/clients/mandiricoal.png";
import imgclient6 from "../../../assets/images/clients/merdeka.png";
import imgclient7 from "../../../assets/images/clients/ppsdm.png";
import imgclient8 from "../../../assets/images/clients/neo.png";
import imgclient9 from "../../../assets/images/clients/bsi.png";
import imgclient10 from "../../../assets/images/clients/biru.png";

const PartnerClient = () => {
    const partners = [
        {
            id: 1,
            title: "Virtual Mining Simulator",
            image: imgpartner1
        },
        {
            id: 2,
            title: "Operator Performance System",
            image: imgpartner2
        },
        {
            id: 3,
            title: "Fleet Management System",
            image: imgpartner3
        },
    ]

    const clients = [
        {
            id: 1,
            title: "PPSDM Geominerba",
            image: imgclient7
        },
        {
            id: 2,
            title: "Coal Mine",
            image: imgclient2
        },
        {
            id: 3,
            title: "Putra Perkasa Abadi",
            image: imgclient3
        },
        {
            id: 4,
            title: "Vale Indonesia",
            image: imgclient4
        },
        {
            id: 5,
            title: "Mandala Karya Prima",
            image: imgclient5
        },
        {
            id: 6,
            title: "Merdeka Copper Gold",
            image: imgclient6
        },
        {
            id: 7,
            title: "Neo Energy",
            image: imgclient8
        },
        {
            id: 8,
            title: "Bumi Suksesindo",
            image: imgclient9
        },
        {
            id: 9,
            title: "Bisa Ruang Nuswantara",
            image: imgclient10
        },
    ]

    return (
        <section id={FEATURE_ID.PARTNER_CLIENT} className="service__section p_relative see__pad" style={{ paddingTop: "120px" }}>
            <div className="auto-container" style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
                <div className="sub__title">
                    <h4>Our Partners & Products</h4>
                </div>
                <div className="row">
                    {partners.map(partner => (
                        <div key={partner.id} className="col-lg-4 col-sm-12" style={{ marginTop: "32px" }}>
                            <div className='partner_client_item_wrapper'>
                                <div className="img__box">
                                    <img src={partner.image} style={{ height: "100px" }} alt={partner.title} />
                                </div>
                                <h6>{partner.title}</h6>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            <div style={{ margin: "64px 0" }}></div>

            <div className="auto-container" style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
                <div className="sub__title">
                    <h4>Our Clients</h4>
                </div>
                <div className="row">
                    {clients.map(client => (
                        <div key={client.id} className="col-lg-4 col-sm-12" style={{ marginTop: "32px" }}>
                            <div className='partner_client_item_wrapper'>
                                <div className="img__box">
                                    <img src={client.image} style={{ height: "100px" }} alt={client.title} />
                                </div>
                                <h6>{client.title}</h6>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    )
}

export default PartnerClient